import { linkWebAccessibilty } from "./web-accessibility/links";

/*use node 18.17.0*/
function init() {
  linkWebAccessibilty();
}

document.addEventListener("DOMContentLoaded", init);
